import { useState } from 'react';
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Visibility, VisibilityOff, WarningAmber } from '@mui/icons-material';

export const ValidatedInput = ({
  autoFocus,
  errorMessage,
  id,
  isValid,
  onChange,
  type,
  defaultValue,
}: {
  autoFocus?: boolean;
  errorMessage: string;
  id: string;
  isValid: boolean;
  onChange: (value: string) => void;
  type?: string;
  defaultValue?: string;
}) => {
  const [hasValidationError, setHasValidationError] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (type === 'password')
    return (
      <FormControl
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: '100%',
        }}
      >
        <OutlinedInput
          defaultValue={defaultValue}
          error={hasValidationError}
          fullWidth
          id={id}
          inputProps={{ autoFocus: !isMobile && autoFocus }}
          onBlur={(e) => {
            setHasValidationError(!isValid && e.target.value.length > 0);
          }}
          onChange={(e) => {
            setHasValidationError(false);
            onChange(e.target.value);
          }}
          size="small"
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword((show) => !show)}
                onMouseDown={(event) => event.preventDefault()}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        {hasValidationError && (
          <FormHelperText error id="password">
            <WarningAmber
              sx={{
                fontSize: '12px',
                marginBottom: '-1px',
                marginRight: '4px',
              }}
            />
            {errorMessage}
          </FormHelperText>
        )}
      </FormControl>
    );

  return (
    <TextField
      defaultValue={defaultValue}
      error={hasValidationError}
      fullWidth
      helperText={hasValidationError ? errorMessage : null}
      id={id}
      inputProps={{ autoFocus: !isMobile && autoFocus }}
      onBlur={(e) => {
        setHasValidationError(!isValid && e.target.value.length > 0);
      }}
      onChange={(e) => {
        setHasValidationError(false);
        onChange(e.target.value);
      }}
      size="small"
      variant="outlined"
      type={type}
    />
  );
};
